// extracted by mini-css-extract-plugin
module.exports = {"dialogOverlay":"dialog_dialogOverlay__wniPN"};